var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import * as React from 'react';
import { connect } from 'react-redux';
import * as classNames from 'classnames';
import { Manager, Target, Popper } from 'react-popper';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import { MenuItem, Icon, MenuList } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { sortBy } from 'lodash';
import Apps from '@material-ui/icons/Apps';
import { getTranslation } from '../../../translation';
import RouterLink from 'src/components/reusable/RouterLink';
var menuItemHeight = 48;
var menuItemCount = 8;
var styles = function (theme) { return ({
    root: {
        display: 'flex',
        width: 60,
        justifyContent: 'center',
    },
    paper: {
        marginRight: theme.spacing.unit * 2,
    },
    popperClose: {
        pointerEvents: 'none',
    },
    dropdown: {
        display: 'flex',
        backgroundColor: 'white',
        boxShadow: 'none',
        '-ms-overflow-style': 'none',
    },
    iconSmall: {
        fontSize: 40,
        paddingRight: 5,
    },
    channelsMenu: {
        width: '100%',
        '& a + div': {
            opacity: 0,
            pointerEvents: 'none',
        },
        '& a:hover + div': {
            pointerEvents: 'unset',
            opacity: 1,
        },
        '& a:hover': {
            pointerEvents: 'unset',
            opacity: 1,
        },
        '& div:hover': {
            pointerEvents: 'unset',
            opacity: 1,
        },
    },
    channelWrapper: {
        opacity: '1 !important',
        position: 'relative',
        backgroundColor: 'white',
    },
    nestedPopper: {
        transform: 'none !important',
        left: '100% !important',
    },
    menuWrapper: {
        border: '1px #e0e0e0 solid',
        width: '100%',
    },
    menu: {
        height: menuItemCount * menuItemHeight,
        maxHeight: menuItemCount * menuItemHeight,
        'overflow-x': 'hidden',
        paddingTop: 0,
    },
    menuLink: {
        display: 'flex',
        justifyContent: 'space-between',
        '&:hover': {
            textDecoration: 'none !important',
        },
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        marginRight: 15,
    },
    scrollIcon: {
        display: 'flex',
        justifyContent: 'center',
        cursor: 'pointer',
    },
    menuItemLink: {
        display: 'flex',
        justifyContent: 'space-between',
    },
}); };
var MenuListComposition = /** @class */ (function (_super) {
    __extends(MenuListComposition, _super);
    function MenuListComposition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            open: false,
            selectedChannels: [],
            scrolledMenus: {},
        };
        _this.getChannels = function (parentId) {
            return sortBy(_this.props.channels.filter(function (channel) { return channel.parent === parentId; }), 'name');
        };
        _this.handleOpen = function () {
            _this.setState({ open: true, selectedChannels: [] });
        };
        _this.handleClose = function () {
            _this.setState({ open: false, selectedChannels: [] });
        };
        _this.onSelectChannel = function (channelId, depth) { return function () {
            _this.setState({
                selectedChannels: __spreadArray(__spreadArray([], _this.state.selectedChannels.slice(0, depth)), [channelId]),
            });
        }; };
        _this.onUnselectChannel = function (depth) { return function () {
            _this.setState({
                selectedChannels: _this.state.selectedChannels.slice(0, depth),
            });
        }; };
        _this.onScrollDown = function (depth) { return function () {
            var _a;
            var element = document.getElementById("scroll-menu-" + depth);
            var scrollTo = menuItemHeight + (_this.state.scrolledMenus["depth-" + depth] || 0);
            if (scrollTo > element.scrollHeight - menuItemHeight * (menuItemCount - 1)) {
                return;
            }
            element.scrollTop = scrollTo;
            _this.setState({
                scrolledMenus: __assign(__assign({}, _this.state.scrolledMenus), (_a = {}, _a["depth-" + depth] = scrollTo, _a)),
            });
        }; };
        _this.onScrollUp = function (depth) { return function () {
            var _a;
            var element = document.getElementById("scroll-menu-" + depth);
            var scrollTo = _this.state.scrolledMenus["depth-" + depth] - menuItemHeight;
            element.scrollTop = scrollTo;
            _this.setState({
                scrolledMenus: __assign(__assign({}, _this.state.scrolledMenus), (_a = {}, _a["depth-" + depth] = scrollTo, _a)),
            });
        }; };
        return _this;
    }
    MenuListComposition.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, classes = _b.classes, loading = _b.loading, translate = _b.translate, tubeColor = _b.tubeColor;
        var _c = this.state, open = _c.open, selectedChannels = _c.selectedChannels, scrolledMenus = _c.scrolledMenus;
        return (React.createElement(Manager, { className: classes.root },
            React.createElement(Target, null,
                React.createElement(Button, { id: "select-channel-btn", className: classes.selectButton, "aria-owns": open ? 'menu-list-grow' : null, "aria-haspopup": "true", onClick: this.handleOpen },
                    React.createElement(Apps, { className: classNames(classes.leftIcon, classes.iconSmall) }))),
            React.createElement(Popper, { placement: "bottom-start", eventsEnabled: open, className: classNames((_a = {}, _a[classes.popperClose] = !open, _a), classes.channelsMenu) },
                React.createElement(ClickAwayListener, { onClickAway: this.handleClose },
                    React.createElement(Grow, { in: open, style: { transformOrigin: '0 0 0' } },
                        React.createElement(Paper, { className: classNames(classes.dropdown) }, loading ? (translate('loading')) : (React.createElement("div", { className: classes.menuWrapper },
                            scrolledMenus['depth-0'] ? (React.createElement("div", { className: classes.scrollIcon, onClick: this.onScrollUp(0) },
                                React.createElement(Icon, null, "expand_less"))) : null,
                            React.createElement(MenuList, { id: "scroll-menu-0", role: "menu", className: classNames('channels-menu', classes.menu) }, this.getChannels(localStorage.getItem('tubeId')).map(function (channel) { return (React.createElement(React.Fragment, { key: channel.id },
                                React.createElement(MenuItem, { className: classes.menuItemLink, style: Boolean(selectedChannels.length) && channel.id === selectedChannels[0]
                                        ? { backgroundColor: tubeColor }
                                        : {} },
                                    React.createElement(RouterLink, { id: "channel-" + (channel.name || '').replace(/\s{1,}/g, '-') + "-link", to: "/channel/" + channel.id + "/home", className: classes.menuLink, onClick: _this.handleClose, style: Boolean(selectedChannels.length) && channel.id === selectedChannels[0]
                                            ? { color: 'white' }
                                            : {} }, channel.name),
                                    _this.getChannels(channel.id).length && selectedChannels[0] === channel.id ? (React.createElement(Icon, { onClick: _this.onUnselectChannel(0) }, "expand_less")) : _this.getChannels(channel.id).length ? (React.createElement(Icon, { onClick: _this.onSelectChannel(channel.id, 0) }, "expand_more")) : null),
                                selectedChannels[0] === channel.id
                                    ? selectedChannels.map(function (selectedChannel, index) { return (React.createElement(MenuList, { key: selectedChannel.id + "-" + index, id: "scroll-menu-" + (index + 1), role: "menu", style: {
                                            backgroundColor: '#fafafa',
                                            paddingTop: 0,
                                            paddingLeft: (index + 1) * 20,
                                        } }, _this.getChannels(selectedChannel).map(function (channel) { return (React.createElement(MenuItem, { key: channel.id, className: classes.menuItemLink, style: channel.id === selectedChannels[index + 1] ? { backgroundColor: tubeColor } : {} },
                                        React.createElement(RouterLink, { id: "selected-channel-" + (channel.name || '').replace(/\s{1,}/g, '-') + "-link", name: channel.name, to: "/channel/" + channel.id + "/home", className: classes.menuLink, onClick: _this.handleClose, style: channel.id === selectedChannels[index + 1] ? { color: 'white' } : {} }, channel.name),
                                        _this.getChannels(channel.id).length &&
                                            selectedChannels[index + 1] === channel.id ? (React.createElement(Icon, { onClick: _this.onUnselectChannel(index + 1) }, "expand_less")) : _this.getChannels(channel.id).length ? (React.createElement(Icon, { onClick: _this.onSelectChannel(channel.id, index + 1) }, "expand_more")) : null)); }))); })
                                    : null)); })),
                            this.getChannels(localStorage.getItem('tubeId')).length > 10 ? (React.createElement("div", { id: "expand-more-icon", className: classes.scrollIcon, onClick: this.onScrollDown(0) },
                                React.createElement(Icon, null, "expand_more"))) : null))))))));
    };
    return MenuListComposition;
}(React.PureComponent));
var mapStateToProps = function (state) { return ({
    translate: getTranslation(state.translation.lang),
    tubeColor: state.auth.tube.color,
}); };
// @ts-ignore
export default withStyles(styles)(connect(mapStateToProps)(MenuListComposition));



//////////////////
// WEBPACK FOOTER
// ./src/components/layouts/Main/MobileChannelList.tsx
// module id = 2047
// module chunks = 81